/**
 * Mobile Navigation
 */
const searchLogic = {
  initSearch: () => {
    const searchCanvas = document.getElementById('search');
    const openSearch = document.querySelectorAll('.search-link');
    const closeSearch = document.querySelectorAll('.close-search');
    const searchForm = document.querySelector('.searchform');

    // // open menu listener
    openSearch.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        searchCanvas.classList.add('active');
        document.querySelector('.search-input').focus();
      });
    });

    // // close click listeners
    closeSearch.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        searchCanvas.classList.remove('active');
      });
    });

    // esc key to exit menu
    document.onkeydown = (e) => {
      e = e || window.event;
      let isEscape = false;
      if ('key' in e) {
        isEscape = e.key === 'Escape' || e.key === 'Esc';
      } else {
        isEscape = e.keyCode === 27;
      }
      if (isEscape) {
        searchCanvas.classList.remove('active');
      }
    };

    // Replace the validation UI for search to match our other forms
    searchLogic.overrideBrowserValidation(searchForm);
  },
  overrideBrowserValidation: (form) => {
    /* eslint-disable */
    // Suppress the default bubbles
    form.addEventListener(
      'invalid',
      (e) => {
        e.preventDefault();
      },
      true
    );
    /* eslint-enable */

    // form submissions by default
    form.addEventListener('submit', (e) => {
      if (!form.checkValidity()) {
        e.preventDefault();
      }
    });

    const submitButton = form.querySelector('button[type=submit]');

    submitButton.addEventListener('click', () => {
      const invalidFields = form.querySelectorAll(':invalid');
      const errorMessages = form.querySelectorAll('.error-message');

      // Remove any existing messages
      for (let i = 0; i < errorMessages.length; i++) {
        errorMessages[i].parentNode.removeChild(errorMessages[i]);
      }

      for (let i = 0; i < invalidFields.length; i++) {
        parent = invalidFields[i].parentNode;
        parent.insertAdjacentHTML(
          'beforeend',
          `<div class="error-message">${invalidFields[i].validationMessage}</div>`
        );
      }

      // If there are errors, give focus to the first invalid field
      if (invalidFields.length > 0) {
        invalidFields[0].focus();
      }
    });
  },
};

export default searchLogic;
